"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var experimentToggleListType_1 = require("../experiment/experimentToggleListType");
var processList_1 = require("../utils/processList");
/**
 * Toggle bullet at selection
 * If selection contains bullet in deep level, toggle bullet will decrease the bullet level by one
 * If selection contains number list, toggle bullet will convert the number list into bullet list
 * If selection contains both bullet/numbering and normal text, the behavior is decided by corresponding
 * browser execCommand API
 * @param editor The editor instance
 */
function toggleBullet(editor) {
    if (editor.useExperimentFeatures()) {
        experimentToggleListType_1.default(editor, 2 /* Unordered */);
    }
    else {
        editor.focus();
        editor.addUndoSnapshot(function () { return processList_1.default(editor, "insertUnorderedList" /* InsertUnorderedList */); }, "Format" /* Format */);
    }
}
exports.default = toggleBullet;
//# sourceMappingURL=toggleBullet.js.map